import $ from 'jquery';

export default class Tooltip {
    options = {};
    selector = undefined;
    _tooltip = undefined;
    className = 'tooltip';

    constructor(selector, options) {
        this.selector = selector;
        this.options = options || {};
        this._tooltip = $('<div class="' + this.className + '"></div>');

        $(document).on('mouseenter', selector, this.handleMouseEnter.bind(this));
    }

    initTooltip($target, $tooltip) {
        let posLeft,
            posTop,
            offset = $target.offset();

        $tooltip.addClass($target.attr('data-tooltipcls'));

        $tooltip.css('width', $tooltip.width() / 2);

        posLeft = offset.left + ($target.outerWidth() / 2) - ($tooltip.outerWidth() / 2);
        posTop = offset.top - $tooltip.outerHeight() - 25;

        if (posLeft < 0) {
            posLeft = offset.left + $target.outerWidth() / 2 - 20;
            $tooltip.addClass('left');
        } else {
            $tooltip.removeClass('left');
        }

        if (posLeft + $tooltip.outerWidth() > $(window).width()) {
            posLeft = offset.left - $tooltip.outerWidth() + $target.outerWidth() / 2 + 20;
            $tooltip.addClass('right');
        } else {
            $tooltip.removeClass('right');
        }

        let isTop = posTop < 0;
        if (posTop < 0) {
            posTop = offset.top + $target.outerHeight();
            $tooltip.addClass('top');
        } else {
            $tooltip.removeClass('top');
        }

        $tooltip.css({
            left: posLeft,
            top: isTop ? posTop + 30 : posTop
        }).animate({
            top: isTop ? '-=10' : '+=10',
            opacity: 1
        }, 50);
    }

    handleMouseEnter(e) {
        let element = e.target;

        let $this = $(element),
            tip = $this.attr('title'),
            $tooltip = $('<div />');

        if (!tip || tip == '') {
            return false;
        }

        $this.removeAttr('title');
        $tooltip
            .addClass(this.className)
            .attr('data-title', tip)
            .css('opacity', 0)
            .html(tip)
            .appendTo('body');

        this.initTooltip($this, $tooltip);

        $(window).on('resize', this.removeAll.bind(this));
        $this.bind('mouseleave', this.handleRemoveTooltip.bind(this, $tooltip, tip));
        $tooltip.bind('click', this.handleRemoveTooltip.bind(this, $tooltip, tip));
    }

    handleRemoveTooltip($tooltip, tip, e) {
        e.target.setAttribute('title', tip);
        $tooltip.animate({
            top: '-=10',
            opacity: 0
        }, 50, () => {
            $tooltip.remove();
        });
    }

    removeAll() {
        $('.' + this.className).remove();
    }
}


// WEBPACK FOOTER //
// ./src/vendor/tooltip.js